import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const BannerAd = ({ content }) => {
    return content?.thumbnail ? (
        <div className={styles.bannerImage}>
            {content.url ? (
                <a href={content.url} target="_blank">
                    <img className={styles.bannerPic} src={content.thumbnail} />
                </a>
            ) : (
                <img className={styles.bannerPic} src={content.thumbnail} />
            )}
        </div>
    ) : null;
};

BannerAd.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(BannerAd);
